/* eslint-disable */
// @ts-nocheck

import { useContext, useEffect } from 'react'
import { SubmitHandler, useFieldArray, useForm } from 'react-hook-form'

import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline'

import Input from '../../../components/forms/Input'
import Button from '../../../components/misc/Button'
import { BasicType } from '../../../interfaces/InterfacesLocal'
import { EditClientCtx } from './EditOnlineClientContainer'

const EditPhones = () => {
  const { client, editClient } = useContext(EditClientCtx)
  const { control, handleSubmit, formState } = useForm({ mode: 'onChange' })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'phones',
  })

  useEffect(() => {
    const phones = client?.phones.map((item) => ({
      number: item.number,
      description: item.description,
    }))
    append(phones)
  }, [])

  const onSubmit: SubmitHandler<BasicType> = (data) => {
    editClient && editClient(client?.id, data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="h-96">
        {fields.map((item, idx) => (
          <div className="inline-flex w-full gap-2" key={item.id}>
            <div className="grid w-full grid-cols-2 gap-2" key={item.id}>
              <Input
                control={control}
                label="Teléfono"
                name={`phones.${idx}.number`}
                rules={{ required: 'Llene los datos o elimine el campo' }}
                textAsNumber
              />
              <Input
                control={control}
                label="Descripción"
                name={`phones.${idx}.description`}
                rules={{ required: 'Llene los datos o elimine el campo' }}
              />
            </div>
            <div className="flex items-end py-2">
              <Button
                action={() => remove(idx)}
                color="red-500"
                icon={<TrashIcon className="h-5" />}
              />
            </div>
          </div>
        ))}
        <div className="mt-5 flex justify-end gap-2">
          <Button
            action={() => append({})}
            color="slate-400"
            full
            icon={<PlusIcon className="h-5" />}
            name="Insertar"
            outline
            textColor="slate-500"
          />
        </div>
      </div>
      <div className="mt-3 flex justify-end">
        <Button color="slate-600" name="Actualizar" type="submit" />
      </div>
    </form>
  )
}

export default EditPhones
